export function convertToDecimalWithPrecision(number, precision, scale) {
	/*const power = Math.pow(10, precision);
	return (parseInt(number*power)/power).toFixed(precision);*/
	const numberWithPrecision = new Number(number).toPrecision(precision);
	return new Number(numberWithPrecision).toFixed(scale);
}
